import {Box} from "@mui/system";
import _ from "lodash";
import FacebookMediaCardEmptyState from "./FacebookMediaCardEmptyState";
import useFacebookMedia from "../../../../hooks/Message/Conversation/useFacebookMedia";
import {metaMediaType} from "../../../../utilities/MetaUtils";

export default function FacebookImageCard({ photoId }) {
    const { loading, media, error } = useFacebookMedia(photoId, metaMediaType.PHOTO);

    if(loading || _.isEmpty(media)) {
        return <FacebookMediaCardEmptyState/>;
    }

    const addDefaultSrc = (ev) => {
        ev.target.src = '';
    };

    return (
        <Box>
            <img src={`${media?.url}`}
                 onError={addDefaultSrc}
                 alt={'image'}
                 style={{...styles.image, ...{width: `${media?.width}px`, maxWidth: `300px`}}}
            />
        </Box>
    )
}

const styles = {
    image: {
        borderRadius: '5px',
        border: '1px solid #C1C1C1'
    },
}